import styles from "./pendingActionwidget.module.css";
import { getPendingActionData } from "../../../../redux/actions/home/home.action";
import { connect } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { dashboardTime, isWidgetPresent } from "../../../../utils/arrayUtils";
import Shimmer from "../../../../components/shimmer/Shimmer";
import {actionRouteMap,ACTIONS_NAMES,getActionLabel} from "../../../../utils/constants/homeConstants";
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import {FUNCTIONAL_ROLES_CONSTANTS,USER_TYPE,} from "../../../../utils/constants/userConstants";
import { Link, useNavigate } from "react-router-dom";

const PendingActionwidget = ({ action, pendingActionData, ...props }) => {
  const data = pendingActionData?.pendingActions;
  const [isOverflowing, setIsOverflowing] = useState({});
  const [expandedIndex, setExpandedIndex] = useState(null);
  const textRefs = useRef([]);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const newOverflowing = {};
      textRefs.current.forEach((el, index) => {
        if (el) {
          newOverflowing[index] = el.scrollHeight > el.clientHeight;
        }
      });
      setIsOverflowing(newOverflowing);
    });

    // Delay observing until DOM is painted
    const timeout = setTimeout(() => {
      textRefs.current.forEach((el) => el && observer.observe(el));
    }, 0);

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    // isWidgetPresent(props?.myRights?.widgetDetails,action)&&
    props?.getPendingActionData(action);
  }, []);
  const handleRetry = (action) => {
    props?.getPendingActionData(action);
  };

  const goto = (item) => {
    const route = actionRouteMap[item?.actionType];
    if (!route) {
      console.log("No route defined for action type:", item?.actionType);
      return "#";
    }
    const role = props?.myRights?.functionalRoles[0];
    const isProvideMoreInfo = item.actionType === ACTIONS_NAMES?.PROVIDE_MORE_INFORMATION?.VALUE;
    if (
      (role === FUNCTIONAL_ROLES_CONSTANTS["account_manager_internal"]?.value ||
       role === FUNCTIONAL_ROLES_CONSTANTS["super_admin_internal"]?.value) &&
      isProvideMoreInfo
    ) {
      return `/user-management/OnboardingRequestDetail/${item?.id}`;
    }
    return `${route}/${item?.id}`;
  };
  

  return (
    <div className={styles.pendingactioncard}>
      {/* <div className={styles.pendingnote}>Action Required</div> */}
      <div className={styles.palabelwrapper}>
        <div className={styles.palabel}>
          Pending Actions
          <span className={styles.pacount}>{data?.length ?? 0}</span>
        </div>
        {(data?.length === 0 || !data) && !props?.isLoading && (
          <SecondaryTooltip text={"Refresh"} positions={["bottom", "right"]}>
            <div
              className={styles.retryparenticon}
              onClick={() => handleRetry(action)}
            >
              <div className={styles.refreshicon}></div>
            </div>
          </SecondaryTooltip>
        )}
      </div>
      {props?.isLoading ? (
        <div className={styles.pabody}>
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className={`${styles.loading} ${index === 0 && styles.bordertop}`}
            >
              <Shimmer />
            </div>
          ))}
        </div>
      ) : (
        <div className={`${styles.pabody} ${(data?.length === 0 || !data)&&styles.nodata}`}>
          {(data?.length === 0 || !data) ? (
            <EmptyDataView />
          ) : (
            data?.map((item, index) => {
              const isExpanded = expandedIndex === index;
              return (
              <Link to={goto(item)} target="_blank" rel="noopener noreferrer" className={styles.removelink}>   
                <div
                  key={index}
                  className={`${styles.pacontainer} ${
                    index === 0 && styles.bordertop
                  }`}
                  tabIndex={0}
                  role="button"
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' '); }}
                >
                  <div className={styles.pawrapper}>
                    <div className={styles.header}>
                      <div className={styles.request}>
                        <div className={styles.reqtype}>
                          {getActionLabel(item?.actionType, item)}
                        </div>
                        <div className={styles.parent}><div className={styles.rightarrow}></div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pendingActionData: state?.dashBoardCounts?.pendingActionData?.data,
    isLoading: state?.dashBoardCounts?.pendingActionData?.isLoading,
    myRights: state.myRights.myRights,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getPendingActionData: (action) => {
      return dispatch(getPendingActionData(action));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingActionwidget);
